import ProductInfoForm from "./productInfoForm.container";

export default ProductInfoForm;
